export default __webpack_public_path__ + "assets/f2ced38621d564e50d77e73547ee726a.svg";